import React from 'react';

const NoReviewsFound = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/no-reviews-found.png"} width="300" />
    </div>;
}

export default NoReviewsFound;